import { useWindowSize } from 'react-use';

type ImageSizeFormat = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const getSize = (size: number): ImageSizeFormat => {
  if (size < 768) {
    return 'xs';
  }
  if (size < 1024) {
    return 'sm';
  }
  if (size < 1200) {
    return 'md';
  }
  if (size < 1600) {
    return 'lg';
  }
  return 'xl';
};

function useBreakPoint() {
  const { width } = useWindowSize();
  const resolvedWidth = width ?? window.innerWidth;

  return getSize(resolvedWidth);
}

export default useBreakPoint;
